module.exports = __webpack_public_path__ + "static/img/xls.03c6c066.png";